<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Organization</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="organization.id === null">New</span>
              <span v-else>
                {{ organization.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="organization.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
              <div class="col-sm-9">
                <textarea rows="5" v-model="organization.address" class="form-control"></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="organization.email"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
              <div class="col-sm-9">
                <input type="text" v-model="organization.phone" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="logo" class="col-sm-3 col-form-label text-left">Logo</label>
              <div class="col-sm-9">
                <input type="text" v-model="organization.logo" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="createOrganization" class="btn btn-sm btn-primary pull-right" v-if="organization.id === null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
        <button type="button" @click="updateOrganization" class="btn btn-sm btn-primary pull-right" v-else><i class="fa fa-save" aria-hidden="true"></i> Update</button>
      </div>
    </div>
    <pre>
      <!-- {{ organization }} -->
    </pre>
  </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, organizationUrl } from '../../config'

export default {
  name: 'OrganizationForm',
  props: ['organization'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateOrganization: function () {
      Axios.put(organizationUrl + '/' + this.organization.id, this.organization, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    createOrganization: function () {
      Axios.post(organizationUrl, this.organization, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    }
  }
}
</script>
